<div class="adaptive-grow-1">
  <div class="fluent-container">
    <br />
    <div class="title-color">
      @if (!sourcefoundingselected) {
        <h1 class="title">Crear fuente de financiación</h1>
      }
    </div>
    <div class="title-color">
      @if (sourcefoundingselected) {
        <h1 class="title">Editar fuente de financiación</h1>
      }
    </div>
    <div class="form-body">
      <form [formGroup]="sourcefoundingForm" (ngSubmit)="saveSourcefounding()">
        <div class="line">
          <div class="form-grid">
            <mat-form-field appearance="outline">
              <mat-label>Nombre</mat-label>
              <input
                type="text"
                matInput
                placeholder="Nombre"
                formControlName="name"
                maxlength="150"
                required
                oninput="this.value = this.value.toUpperCase()"
              />
              @if (sourcefoundingForm.get('name')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
              @if (sourcefoundingForm.get('name')?.hasError('maxlength')) {
                <mat-error class="for-text text-danger">
                  Se permiten máximo 150 caracteres
                </mat-error>
              }
            </mat-form-field>

            <mat-form-field appearance="outline">
              <mat-label>Descripción</mat-label>
              <textarea
                matInput
                placeholder="Descripción"
                formControlName="description"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></textarea>
              @if (sourcefoundingForm.get('description')?.hasError('required')) {
                <mat-error class="for-text text-danger"> Campo obligatorio </mat-error>
              }
            </mat-form-field>
          </div>
        </div>
        <button type="submit" class="primary-button" [disabled]="!sourcefoundingForm.touched">
          <span class="button-content"> <mat-icon fontIcon="save"></mat-icon>Guardar </span>
        </button>

        <button type="button" (click)="closeDialog()" class="secondary-button" id="cancelar">
          <span class="button-content"><mat-icon>close</mat-icon>Cancelar</span>
        </button>
      </form>
    </div>
  </div>
</div>
